import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  convertRole,
  convertAccountStatus,
  convertRemoteSupportStatus,
} from '../../lib/tools';
import {
  Main,
  HeaderItem,
  Tr,
  BaseTd,
  ListHead,
  ScrolledBody,
  StyledTable,
  Tbody,
  Thead,
  HeaderWrapper,
} from './styles/StaffListsStyles';

/**
 * 表のヘッダーコンポーネント
 * @param {boolean} isServiceVenderUser - サービスベンダー企業所属ユーザーかどうかの真偽値
 * @return {ReactElement}
 */
const createHeader = isServiceVenderUser => (
  <ListHead>
    <HeaderItem>
      <FormattedMessage id="operator.OperatorLists.title.userName" />
    </HeaderItem>
    {isServiceVenderUser ? (
      <HeaderItem>
        <FormattedMessage id="operator.OperatorLists.title.companyName" />
      </HeaderItem>
    ) : (
      <HeaderItem>
        <FormattedMessage id="operator.OperatorLists.title.mailAddress" />
      </HeaderItem>
    )}
    <HeaderItem>
      <FormattedMessage id="operator.OperatorLists.title.role" />
    </HeaderItem>
    <HeaderItem>
      <FormattedMessage id="operator.OperatorLists.title.license" />
    </HeaderItem>
    <HeaderItem>
      <FormattedMessage id="operator.OperatorLists.title.remoteSupportLicense" />
    </HeaderItem>
  </ListHead>
);

/**
 * 表の行を表示するコンポーネント
 * @param {number} idx - ユーザーのインデックス
 * @param {Object} userData - ユーザー情報
 * @param {Function} onSelect - 行の選択時のコールバック関数
 * @param {boolean} isServiceVenderUser - サービスベンダー企業所属ユーザーかどうかの真偽値
 * @return {ReactElement} 表の行要素
 */
const createListItem = (idx, userData, onSelect, isServiceVenderUser) => {
  const onClickOperator = `onClickOperator${idx}`;
  const role = convertRole(userData.role);
  const accountStatus = convertAccountStatus(
    userData.accountStatus,
    userData.role,
  );
  const remoteSupportStatus = convertRemoteSupportStatus(
    userData.remoteSupportStatus,
  );

  return (
    <Tr
      className="clickableItem"
      id={onClickOperator}
      key={onClickOperator}
      onClick={() => {
        onSelect(
          userData.operatorId,
          userData.companyCode,
          userData.accountStatus,
        );
      }}
    >
      <BaseTd>{userData.name || ''}</BaseTd>
      {isServiceVenderUser ? (
        <BaseTd>{userData.companyName}</BaseTd>
      ) : (
        <BaseTd>{userData.userId}</BaseTd>
      )}
      <BaseTd>{role}</BaseTd>
      <BaseTd>{accountStatus}</BaseTd>
      <BaseTd>{remoteSupportStatus}</BaseTd>
    </Tr>
  );
};

/**
 * ユーザー管理画面のユーザー一覧表
 * @param {Object} props
 * @param {Array} props.operators - ユーザー情報の配列
 * @param {Function} props.onSelect - ユーザー選択時のコールバック関数
 * * @param {boolean} props.isServiceVenderUser - サービスベンダー企業所属ユーザーかどうかの真偽値
 * @return {ReactElement}
 */
const StaffLists = ({ operators, onSelect, isServiceVenderUser }) => (
  <Main className="OperatorListsts">
    <HeaderWrapper>
      <StyledTable>
        <Thead>{createHeader(isServiceVenderUser)}</Thead>
      </StyledTable>
    </HeaderWrapper>
    <ScrolledBody id="canStaffScrollTable">
      <StyledTable>
        <Tbody>
          {operators &&
            operators.map((list, idx) =>
              createListItem(idx, list, onSelect, isServiceVenderUser),
            )}
        </Tbody>
      </StyledTable>
    </ScrolledBody>
  </Main>
);

StaffLists.propTypes = {
  isServiceVenderUser: PropTypes.bool.isRequired,
  operators: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default StaffLists;
